import { ApiProperty } from '@nestjs/swagger';
import { IsNotEmpty, IsString } from 'class-validator';

export class PusherAuthenticateInputModel {
  @ApiProperty()
  @IsNotEmpty()
  @IsString()
  public socket_id!: string;
}
